<template>
  <div class="summaryB">
        <div class="B_one fx">
            <div class="B_one_left wow animate__fadeInLeftBig">
                <div class="fw_5 fs_02 mb006">企业价值观 <span class="ml002">-</span></div>
                <div class="fs_0075 color8 mb02">CORPATE VALUES</div>
                <div class="fx_l f_j_sb">
                    <div class=" Litem fx f_j_sb mb02" v-for="(item,index) in leftlist ">
                        <div class="">
                            <div class="text1 fs_015 fw_8 color4">{{item.text1}}</div>
                            <div class="text2 fs_065 color10">{{item.text2}}</div>
                            <div class="text3 fw_8 fs_01 color1">+</div>
                        </div>
                        <img :src="item.img" style="width:52%;">
                    </div>
                </div>
            </div>
            <div class="B_one_right wow  animate__fadeInRightBig">
                <div class="fw_5 fs_02 mb006">企业主张 <span class="ml002">-</span></div>
                <div class="fs_0075 color8 mb02">CORPORATE PROPOSITION</div>
                <div class="mb02">
                    <img src="@/assets/computer/wenhua/hc1.png" class="ig">
                    <div class="fs_01 color9 mt003 mb01">可持续发展</div>
                </div>
                <div>
                    <img src="@/assets/computer/wenhua/hc2.png" class="ig">
                    <div class="fs_01 color9 mt003">开放合作共赢</div>
                </div>
            </div>
        </div>
        <div class="B_two">
            <div class="fw_5 fs_02 mb006 wow  animate__fadeInRightBig">企业主张 <span class="ml002">-</span></div>
            <div class="fs_0075 color8 mb02  wow  animate__fadeInRightBig">CORPORATE PROPOSITION</div>
            <div class="qyzz fx pt02 wow animate__backInUp">
                <div v-for="(item,index) in list1" class="prel qyzz_item">
                    <img :src="item.img" class="ig">
                    <div class="qyzz_t1 fs_013">{{ item.text1 }}</div>
                    <div class="qyzz_t2">
                        <div class="fw_8 fs_013 pb_004 ">{{ item.text2 }}</div>
                        <div class="fs_007">{{ item.text3 }}</div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script setup>

 import { useRouter } from 'vue-router'
 import {ref, nextTick, onMounted, reactive,defineProps } from "vue";
 import { Swiper } from 'swiper/vue';
 const router = useRouter()


onMounted(() => {
 
});
const leftlist = ref([
    {
        text1:'创新',
        text2:'INNOVATE',
        img:require('@/assets/computer/wenhua/z179.png')
    },{
        text1:'高效',
        text2:'EFFICIENT',
        img:require('@/assets/computer/wenhua/z178.png')
    },{
        text1:'开放',
        text2:'OPEN',
        img:require('@/assets/computer/wenhua/z180.png')
    },{
        text1:'务实',
        text2:'PRAGMATISM',
        img:require('@/assets/computer/wenhua/z177.png')
    },{
        text1:'严谨',
        text2:'RIGOROUS',
        img:require('@/assets/computer/wenhua/z181.png')
    },
])
const list1=ref([
    {
        text1:'01',
        text2:'为员工',
        text3:'成长搭建新平台',
        img:require('@/assets/computer/wenhua/m22.png')
    },{
        text1:'02',
        text2:'为客户',
        text3:'服务提供新体验',
        img:require('@/assets/computer/wenhua/m5.png')
    },{
        text1:'03',
        text2:'为股东',
        text3:'投资创造新价值',
        img:require('@/assets/computer/wenhua/m6.png')
    },{
        text1:'04',
        text2:'为行为',
        text3:'发展引领新方向',
        img:require('@/assets/computer/wenhua/m7.png')
    },{
        text1:'05',
        text2:'为社会',
        text3:'建设赋予新动能',
        img:require('@/assets/computer/wenhua/m8.png')
    },
])
</script>

<style scoped>
.B_one{
    width: 85%;
    margin: 0 auto;
}
.B_one_left{
    width: 43%;
    margin-right: 17%;
}
.Litem{
    width: 46.5%;
    border: 1px solid red ;
}
.text1{
    padding: 0.19rem 0.1rem 0.05rem;
}
.text2{
    padding: 0 0.1rem 0.08rem;
}
.text3{
    padding: 0 0.1rem;
}
.B_one_right{
    width: 40%;
}
.B_two{
    width: 85%;
    margin: 0 auto;
    padding: 0.3rem 0 1.7rem;
}
.qyzz .qyzz_item:nth-child(odd){
	background: #cccccc;
}
.qyzz .qyzz_item:nth-child(even){
	background: #d20000;
    color: #fff ;
}
.qyzz_item{
    width: 20%;
}
.qyzz_t1{
    position: absolute;
    left: 0.08rem;
    top: 0.2rem;
}
.qyzz_t2{
    position: absolute;
    left: 0.08rem;
    bottom: 0.25rem;
}
</style>
